import { HTTPMethod } from "namirasoft-core";
import { BaseTypeSchema } from "./BaseTypeSchema";
import { BaseVariableSchema } from "./BaseVariableSchema";
import { BaseSchema } from "./BaseSchema";
import { VariableType } from "./VariableType";
import { ObjectSchema } from "./type/ObjectSchema";

export class ControllerSchema extends BaseSchema
{
    name: string;
    tag: string;
    method: HTTPMethod;
    path: string;
    summary: string;
    headers: BaseVariableSchema[] = [];
    parameters: BaseVariableSchema[] = [];
    body: BaseTypeSchema | null = null;
    queries: BaseVariableSchema[] = [];
    output: BaseTypeSchema | null = null;
    constructor(name: string, tag: string, method: HTTPMethod, path: string, summary: string)
    {
        super();
        this.name = name;
        this.tag = tag;
        this.method = method;
        this.path = path;
        this.summary = summary;
    }
    override check(): void
    {
        BaseSchema.checkRepeated("Headers", "item", this.headers, () => "", c => c.name);
        BaseSchema.checkRepeated("Parameters", "item", this.parameters, () => "", c => c.name);
        BaseSchema.checkRepeated("Queries", "item", this.queries, () => "", c => c.name);
        if (this.body)
            this.body.check();
        if (this.output)
            this.output.check();
        let parameters = this.parameters;
        let regex = /\{([^}]+)\}/g;
        let ps: string[] = []
        let match;
        let path = "/" + this.path + "/";
        while ((match = regex.exec(path)) !== null)
            ps.push(match[1]);
        for (let i = 0; i < ps.length; i++)
            if (parameters.filter(p => p.name == ps[i]).length == 0)
                throw new Error(`For controller '${this.tag}.${this.name}', there is a parameter ${ps[i]} is path, but not in getParameterSchema function.`);
        for (let i = 0; i < parameters.length; i++)
            if (!ps.includes(parameters[i].name))
                throw new Error(`For controller '${this.tag}.${this.name}', there is a parameter ${parameters[i].name} is getParameterSchema function, but not in path.`);
    }
    static getArgs(controller: ControllerSchema): BaseVariableSchema[]
    {
        let args: BaseVariableSchema[] = [];
        args.push(...controller.parameters);
        args.push(...controller.queries);
        return args;
    }
    static getOptions(controller: ControllerSchema): BaseVariableSchema[] | null
    {
        let options: BaseVariableSchema[] = [];
        if (controller.body != null)
        {
            if (controller.body.type == VariableType.Object)
            {
                let o = controller.body as ObjectSchema;
                if (o.fields)
                    options.push(...o.fields)
                else
                    return null;
            }
        }
        return options;
    }
}